<template>
  <article class="kds-protocol-card">
    <KdsEyebrow class="kds-protocol-card__eyebrow">{{ eyebrow }}</KdsEyebrow>
    <h3 class="kds-protocol-card__title">{{ title }}</h3>
    <div v-if="$slots.visual" class="kds-protocol-card__visual">
      <slot name="visual" />
    </div>
    <p class="kds-protocol-card__body">{{ body }}</p>
    <p v-if="bestFor" class="kds-protocol-card__footer">
      <span class="kds-protocol-card__footer-label">
        <span class="kds-protocol-card__footer-key">Best for</span>
        <span class="kds-protocol-card__footer-sep">·</span>
      </span>
      <span>{{ bestFor }}</span>
    </p>
  </article>
</template>

<script setup lang="ts">
import KdsEyebrow from '@/kds/primitives/KdsEyebrow.vue';

interface Props {
  eyebrow: string;
  title: string;
  body: string;
  bestFor?: string;
}

withDefaults(defineProps<Props>(), { bestFor: undefined });
</script>

<style scoped lang="scss">
.kds-protocol-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-6);
  background: var(--paper);
  border: var(--border);
  border-radius: var(--r-4);
  transition:
    box-shadow var(--d-base) var(--ease-out),
    border-color var(--d-base) var(--ease-out);

  &:hover {
    box-shadow: var(--shadow-2);
    border-color: var(--mist-2);
  }

  &__visual {
    margin: var(--space-2) 0 var(--space-1);
  }

  &__title {
    margin: 0;
    font-size: var(--fs-h3);
    line-height: var(--lh-h3);
    color: var(--ink);
  }

  &__body {
    margin: 0;
    font-size: var(--fs-body);
    line-height: var(--lh-body);
    color: var(--stone);
  }

  &__footer {
    margin: 0;
    font-family: var(--font-mono);
    font-size: var(--fs-mono);
    color: var(--stone);
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-1) var(--space-2);
  }

  &__footer-label {
    white-space: nowrap;
    flex-shrink: 0;
    display: inline-flex;
    gap: var(--space-2);
  }

  &__footer-key {
    color: var(--ink);
  }

  &__footer-sep {
    color: var(--stone-2);
  }
}
</style>
